import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings.js'
import {
  PhaseCircle,
  PhaseCircleBackground,
  PhaseCircleOutline,
  PhaseCirclePath,
  PhaseLabel,
} from './LifeCylceButtons.style'

const noop = () => {}

const TestButton = ({
  isSelected,
  isSelectable,
  withLabel,
  onClick,
  transformX,
  transformY,
}) => (
  <>
    <PhaseCircle
      isSelected={isSelected}
      isSelectable={isSelectable}
      onClick={isSelectable ? onClick('promoteAction') : noop}
      transform={`translate(${transformX} ${transformY})`}
      data-testid="lifecycle-test-button"
    >
      <PhaseCircleBackground cx="95" cy="13" r="12.5" strokeLinejoin="square" />
      <PhaseCircleOutline
        isSelected={isSelected}
        isSelectable={isSelectable}
        cx="95"
        cy="13"
        r="15"
        strokeWidth="1"
      />
      <PhaseCirclePath
        isSelected={isSelected}
        isSelectable={isSelectable}
        transform="translate(0 -4)"
        strokeWidth="0.1"
        d="M95.778 15.042h3.889v-1.551h-3.89v1.551zm0 5.43h3.889v-1.55h-3.89v1.55zm4.666 3.492H89.556A1.558 1.558 0 0 1 88 22.412v-10.86c0-.854.7-1.552 1.556-1.552h10.888c.856 0 1.556.698 1.556 1.552v10.86c0 .853-.7 1.552-1.556 1.552zm-10.11-7.758h3.888v-3.879h-3.889v3.88zm.777-3.103h2.333v2.327h-2.333v-2.327zm-.778 8.533h3.89v-3.878h-3.89v3.878zm.778-3.103h2.333v2.328h-2.333v-2.328z"
      />
    </PhaseCircle>
    {withLabel && (
      <PhaseLabel
        isSelected={isSelected}
        isSelectable={isSelectable}
        onClick={isSelectable ? onClick('promoteAction') : noop}
        fontFamily="ArialMT, Arial"
        fontSize="12"
        transform="translate(0 4)"
      >
        <tspan x="83.331" y="43">
          {strings.test}
        </tspan>
      </PhaseLabel>
    )}
  </>
)

TestButton.defaultProps = {
  withLabel: true,
  transformX: 0,
  transformY: 4,
}

TestButton.propTypes = {
  isSelected: PropTypes.bool,
  isSelectable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  withLabel: PropTypes.bool,
  onClick: PropTypes.func,
  transformX: PropTypes.number,
  transformY: PropTypes.number,
}

export default TestButton
